module.exports = __webpack_public_path__ + "static/media/comment-alt-medical.025a9621.svg";